import { createContext, useContext } from "react";
import type { useAccessibleShops } from "../../hooks/useAccessibleShops";
import type { ShopData } from "../../types/shopData.type";

export const ShopContext = createContext<
  | {
      shop: ShopData;
      shops: ShopData[];
      requestShopChange: (shopId: number) => void;
      refetchShops: ReturnType<typeof useAccessibleShops>["refetch"];
    }
  | undefined
>(undefined);

export const useShopContext = () => {
  const context = useContext(ShopContext);
  if (!context) throw new Error("ShopProvider is required");
  return context;
};

export const useCurrentShop = () => useShopContext().shop;
